import { useAppState } from "../hooks/use_app_state";
import { StickerMenu } from "./sticker_menu";
import { resolveSticker } from "../core/stickers";
import "./chat_bar.css";

export default function ChatBar() {
  const { dispatch, showStickersMenu } = useAppState();

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const text = formData.get("chatBar") as string;
    if (!text.trim()) return;

    dispatch({
      type: "SEND_MESSAGE",
      payload: { sender: "me", text, timestamp: Date.now() },
    });

    const responses = resolveSticker(text);
    if (responses.length === 0) return;

    dispatch({ type: "SET_ALI_TYPING", payload: true });

    const delay = 1000 + Math.random() * 2000;
    setTimeout(() => {
      dispatch({ type: "SET_ALI_TYPING", payload: false });
      responses.forEach((s, i) => {
        setTimeout(() => {
          dispatch({
            type: "SEND_MESSAGE",
            payload: {
              sender: "ali",
              type: "sticker",
              sticker: s,
              timestamp: Date.now(),
            },
          });
        }, i * 600);
      });
    }, delay);

    e.currentTarget.reset();
  }

  return (
    <div>
      <StickerMenu open={showStickersMenu} />
      <form onSubmit={handleSubmit} className="chat-bar-form">
        <button
          type="button"
          className="chat-bar-sticker-button"
          onClick={() => dispatch({ type: "TOGGLE_STICKERS_MENU" })}
        >
          😊
        </button>
        <input
          name="chatBar"
          placeholder="Type a message"
          className="chat-bar-input"
        />
        <button type="submit" className="chat-bar-send-button">
          ➤
        </button>
      </form>
    </div>
  );
}
